// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "MontserratLight", sans-serif;
}

.leftContent {
  padding-right: 7px;
}

.rightContent {
  padding: 0 7px;
}

.sendContent {
  padding-left: 7px;
}

.form-field {
  height: 75px;
}

#midCol > div {
  margin-bottom: 10px;
}

.wantedReport {
  height: 120px;
}

.creditBox {
  width: 50%;
  padding-left: 40px;
  height: 130px;
}

.modal-body {
  background-color: #EDF2F5;
}

.not-active {
  pointer-events: none;
  cursor: default;
}

.creditBox div:first-child p {
  margin-bottom: 6px;
  padding-bottom: 0;
}

.creditBox div:nth-child(2),
.creditBox div:nth-child(3) {
  border: 1px solid #ccc;
}

.creditBox div:nth-child(2) {
  background-color: rgb(208, 238, 207);
  margin-bottom: 5px;
}

.creditBox div:nth-child(3) {
  background-color: #bebebe;
}

.creditBox div:nth-child(2) p,
.creditBox div:nth-child(3) p {
  margin: 0;
  padding: 0;
  text-align: center;
}

.creditsAvailable, .creditCost {
  padding: 6.5px;
}

button[disabled] {
  opacity: 0.5;
}

.largeButton {
  width: 300px;
  height: 36px;
  background-color: white;
  border: 1px solid #ccc;
  padding: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}

.largeButton:last-child {
  width: 300px;
  margin-bottom: auto;
}

.largeButton:hover {
  background-color: #CCC;
}

.deactivated {
  background-color: #EDF2F5;
}

.bbuttonHover:hover {
  color: inherit;
}

.deactivated:hover {
  background-color: inherit;
}

.mainLargeButton {
  background-color: #666;
  color: white;
}

.reportsCheckboxes {
  width: 70%;
  padding-right: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1165px) {
  .iac-credit-box {
    float: left !important;
  }
}
.leftColumnInfo {
  margin-top: 8px;
}

.lbImageContainer {
  width: 29px;
}

.lbText {
  padding-top: 3px;
}

.creditBoxInner {
  width: 100px;
  margin-bottom: 10px;
}

.creditBoxInner div:first-child p {
  margin-bottom: 6px;
  padding-bottom: 0;
}

.creditBoxInner div:first-child p span,
.reportsCheckboxes p span {
  font-family: MontserratSemiBold, sans-serif;
}

.creditBoxInner div:nth-child(2),
.creditBoxInner div:nth-child(3) {
  border: 1px solid #ccc;
}

.creditBoxInner div:nth-child(2) {
  margin-bottom: 5px;
}

.creditBoxInner div:nth-child(3) {
  background-color: #bebebe;
}

.creditBoxInner div:nth-child(2) p,
.creditBoxInner div:nth-child(3) p {
  margin: 0;
  padding: 0;
  text-align: center;
}

.creditsAvailable, .creditCost {
  padding: 6.5px;
}

.redWarning {
  color: rgb(240, 123, 126);
}

.newSurveyRequest ::ng-deep .modal-body {
  background-color: #EDF2F5;
  padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/web/people-request-send-resend-modal/people-request-send-resend-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,0CAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;AACJ;;AAEA;;EAEI,sBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;;EAEI,SAAA;EACA,UAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI;IACI,sBAAA;EACN;AACF;AAGA;EACI,eAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,YAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,iBAAA;AADJ;;AAGA;;EAEI,2CAAA;AAAJ;;AAEA;;EAEI,sBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;;EAEI,SAAA;EACA,UAAA;EACA,kBAAA;AAIJ;;AADA;EACI,cAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,iBAAA;AAIJ","sourcesContent":["* {\n    font-family: 'MontserratLight',  sans-serif\n}\n\n.leftContent {\n    padding-right: 7px;\n}\n\n.rightContent {\n    padding: 0 7px;\n}\n\n.sendContent {\n    padding-left: 7px;\n}\n\n.form-field {\n    height: 75px;\n}\n\n#midCol > div {\n    margin-bottom: 10px;\n}\n\n.wantedReport {\n    height: 120px;\n}\n\n.creditBox {\n    width: 50%;\n    padding-left: 40px;\n    height: 130px;\n}\n\n.modal-body {\n    background-color: #EDF2F5;\n}\n\n.not-active {\n    pointer-events: none;\n    cursor: default;\n}\n\n.creditBox div:first-child p {\n    margin-bottom: 6px;\n    padding-bottom: 0;\n}\n\n.creditBox div:nth-child(2),\n.creditBox div:nth-child(3) {\n    border: 1px solid #ccc;\n}\n\n.creditBox div:nth-child(2) {\n    background-color: rgb(208, 238, 207);\n    margin-bottom: 5px;\n}\n\n.creditBox div:nth-child(3) {\n    background-color: #bebebe;\n}\n\n.creditBox div:nth-child(2) p,\n.creditBox div:nth-child(3) p {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n\n.creditsAvailable, .creditCost {\n    padding: 6.5px;\n}\n\nbutton[disabled] {\n    opacity: 0.5;\n}\n\n.largeButton {\n    width: 300px;\n    height: 36px;\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 5px;\n    margin-bottom: 5px;\n    cursor: pointer;\n}\n\n.largeButton:last-child {\n    width: 300px;\n    margin-bottom: auto;\n}\n\n.largeButton:hover {\n    background-color: #CCC;\n}\n\n.deactivated {\n    background-color: #EDF2F5;\n}\n\n.bbuttonHover:hover {\n    color: inherit;\n}\n\n.deactivated:hover {\n    background-color: inherit;\n}\n\n.mainLargeButton {\n    background-color: #666;\n    color: white;\n}\n\n.reportsCheckboxes {\n    width: 70%;\n    padding-right: 10px;\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n@media (max-width: 1165px) {\n    .iac-credit-box {\n        float: left !important;\n    }\n}\n\n\n.leftColumnInfo {\n    margin-top: 8px;\n}\n\n.lbImageContainer {\n    width: 29px;\n}\n\n.lbText {\n    padding-top: 3px;\n}\n\n.creditBoxInner {\n    width: 100px;\n    margin-bottom: 10px;\n}\n\n.creditBoxInner div:first-child p {\n    margin-bottom: 6px;\n    padding-bottom: 0;\n}\n.creditBoxInner div:first-child p span,\n.reportsCheckboxes p span {\n    font-family: MontserratSemiBold,  sans-serif;\n}\n.creditBoxInner div:nth-child(2),\n.creditBoxInner div:nth-child(3) {\n    border: 1px solid #ccc;\n}\n.creditBoxInner div:nth-child(2) {\n    margin-bottom: 5px;\n}\n.creditBoxInner div:nth-child(3) {\n    background-color: #bebebe;\n}\n.creditBoxInner div:nth-child(2) p,\n.creditBoxInner div:nth-child(3) p {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n\n.creditsAvailable, .creditCost {\n    padding: 6.5px;\n}\n\n.redWarning {\n    color: rgb(240, 123, 126)\n}\n\n.newSurveyRequest ::ng-deep .modal-body {\n    background-color: #EDF2F5;\n    padding-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
